module.exports = __webpack_public_path__ + "static/media/onconnect.94ac3fc4.jpg";